import { render, staticRenderFns } from "./InfoProduct.vue?vue&type=template&id=79c34033&"
import script from "./InfoProduct.vue?vue&type=script&lang=js&"
export * from "./InfoProduct.vue?vue&type=script&lang=js&"
import style0 from "./InfoProduct.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports